var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-item col"},[_c('label',[_vm._v("Safe Search")]),_c('div',{staticClass:"layout"},_vm._l((_vm.safesearch),function(item,key){return _c('button',{key:key,class:{
        active: _vm.active == item,
      },attrs:{"type":"button","aria-label":`Safe search ${item}`},on:{"click":function($event){return _vm.$emit('changeActive', 'safesearch', item)}}},[_c('span',{staticClass:"status"}),_vm._v(" "+_vm._s(item ? "Yes" : "No")+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }